import { render, staticRenderFns } from "./Comex.vue?vue&type=template&id=12c4aad7&"
import script from "./Comex.vue?vue&type=script&lang=js&"
export * from "./Comex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports